<!-- 
 This transition works with only one child element but can still give the appaerance of a sliding transition
 since when it "leaves" it will slide either left or right and the incoming (new) element will slide in the opposite direction.
 The key is the key for making the transition work since it appears to be a new element to Vue but we still only render one element at a time.

 !important: Remember to disable changing element during the duration of the transition, otherwise it will look strange
 !important: Remember to key the element that is being transitioned, otherwise the transition will not work

 Here is an example of how you can use it:
 (description of the example: the itemPages[currentPage] loads a specific page of items from the items array, so we dont use a for-loop, then the transition would not work.)
<div
	:key="itemPages[currentPage].index"
	class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-6"
>
	<GridCard
		v-for="item in itemPages[currentPage].items"
		:key="item.id"
		:item="item"
		:modelClass="modelClass"
		:divider="false"
	/>
</div>
  -->

<template>
    <div
        :class="[
            duration,
            'relative overflow-hidden [&>*]:transition-transform',
        ]"
    >
        <Transition
            :name="slidingLeft ? 'slide_left' : 'slide_right'"
            @before-leave="$emit('canTransition', false)"
            @after-enter="$emit('canTransition', true)"
        >
            <slot />
        </Transition>
    </div>
</template>

<!--
    TODO, exchange this transition for https://splidejs.com/? Our transition is css and native vue transition. Nice to not depend on external lib.
    But sometimes blinking occurs...
-->
<script>
export default {
    name: 'CarouselTransition',

    emits: ['canTransition'],

    props: {
        slidingLeft: {
            type: Boolean,
            default: false,
        },
        duration: {
            type: String,
            default: '[&>*]:duration-500',
            validator: (value) => {
                if (!/^\[\&\>\*\]:duration-\d{3,4}/.test(value)) {
                    console.error(
                        'The duration prop must be a string in the format of "[&>*]:duration-xxx" where xxx is a number'
                    )
                    return false
                }
                return true
            },
        },
    },
}
</script>
